<div class="relative-container">
  @if (isLoading) {
    <div class="spinner-container">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }
  <div class="calendar-bg">
    <div id="calendar"></div>
  </div>
</div>
